import { helper } from '@ember/component/helper'

interface Signature {
  Args: {
    Positional: [stringInput: string]
    Named: {
      characterLimit?: number
      useEllipsis?: boolean
    }
  }
  Return: string
}

/**
 * Truncates a string down to given character count, with ellipsis.
 *
 * Adapted from, but added types and removed htmlsafe logic.
 * https://github.com/romulomachado/ember-cli-string-helpers/blob/master/addon/helpers/truncate.js
 */
export const truncate = helper<Signature>(function ([stringInput], { characterLimit = 140, useEllipsis = true }) {
  const limit = useEllipsis ? characterLimit - 3 : characterLimit

  if (stringInput && stringInput.length > limit) {
    return useEllipsis ? `${stringInput.substring(0, limit)}...` : stringInput.substring(0, limit)
  } else {
    return stringInput
  }
})

export default truncate
